/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AssetIngestionSearchFilterElementDto } from './AssetIngestionSearchFilterElementDto';
import type { AssetSearchFilterElementDto } from './AssetSearchFilterElementDto';
import type { BaseSearchFilterElementDto } from './BaseSearchFilterElementDto';
import type { CreationMethodSearchFilterElementDto } from './CreationMethodSearchFilterElementDto';
import type { CriticalitySearchFilterElementDto } from './CriticalitySearchFilterElementDto';
import type { CustomMetadataLabelSearchFilterElementDto } from './CustomMetadataLabelSearchFilterElementDto';
import type { CustomMetadataSearchFilterElementDto } from './CustomMetadataSearchFilterElementDto';
import type { CustomMetadataStringSearchFilterElementDto } from './CustomMetadataStringSearchFilterElementDto';
import type { CustomMetadataTeamSearchFilterElementDto } from './CustomMetadataTeamSearchFilterElementDto';
import type { CustomMetadataUserSearchFilterElementDto } from './CustomMetadataUserSearchFilterElementDto';
import type { DataProductSearchFilterElementDto } from './DataProductSearchFilterElementDto';
import type { DatasetSearchFilterElementDto } from './DatasetSearchFilterElementDto';
import type { DbtRunStatusSearchFilterElementDto } from './DbtRunStatusSearchFilterElementDto';
import type { HealthStatusSearchFilterElementDto } from './HealthStatusSearchFilterElementDto';
import type { IncidentMutingStatusSearchFilterElementDto } from './IncidentMutingStatusSearchFilterElementDto';
import type { IncidentStatusSearchFilterElementDto } from './IncidentStatusSearchFilterElementDto';
import type { OwnerSearchFilterElementDto } from './OwnerSearchFilterElementDto';
import type { PlatformSearchFilterElementDto } from './PlatformSearchFilterElementDto';
import type { PlatformTypeSearchFilterElementDto } from './PlatformTypeSearchFilterElementDto';
import type { RuleTemplateNameSearchFilterElementDto } from './RuleTemplateNameSearchFilterElementDto';
import type { TagSearchFilterElementDto } from './TagSearchFilterElementDto';
import type { TeamSearchFilterElementDto } from './TeamSearchFilterElementDto';
import type { UsageSearchFilterElementDto } from './UsageSearchFilterElementDto';
import type { UuidSearchFilterElementDto } from './UuidSearchFilterElementDto';

export type BaseSearchFilterDto = {
    children?: Array<(BaseSearchFilterElementDto | AssetIngestionSearchFilterElementDto | AssetSearchFilterElementDto | CreationMethodSearchFilterElementDto | CriticalitySearchFilterElementDto | CustomMetadataSearchFilterElementDto | DataProductSearchFilterElementDto | DatasetSearchFilterElementDto | DbtRunStatusSearchFilterElementDto | HealthStatusSearchFilterElementDto | IncidentMutingStatusSearchFilterElementDto | IncidentStatusSearchFilterElementDto | OwnerSearchFilterElementDto | PlatformSearchFilterElementDto | PlatformTypeSearchFilterElementDto | RuleTemplateNameSearchFilterElementDto | TagSearchFilterElementDto | TeamSearchFilterElementDto | UsageSearchFilterElementDto | UuidSearchFilterElementDto | CustomMetadataLabelSearchFilterElementDto | CustomMetadataStringSearchFilterElementDto | CustomMetadataTeamSearchFilterElementDto | CustomMetadataUserSearchFilterElementDto)>;
    description?: string;
    query?: string;
    type?: BaseSearchFilterDto.type;
};

export namespace BaseSearchFilterDto {

    export enum type {
        ASSET_TYPE = 'ASSET_TYPE',
        PLATFORM = 'PLATFORM',
        HEALTH_STATUS = 'HEALTH_STATUS',
        TAG = 'TAG',
        TERM = 'TERM',
        USAGE = 'USAGE',
        RULE_STATUS = 'RULE_STATUS',
        CRITICALITY = 'CRITICALITY',
        RULE_TEMPLATE_NAME = 'RULE_TEMPLATE_NAME',
        DATASET = 'DATASET',
        OWNER = 'OWNER',
        ASSET_INGESTION = 'ASSET_INGESTION',
        TECHNOLOGY = 'TECHNOLOGY',
        CREATED_BY = 'CREATED_BY',
        CREATION_METHOD = 'CREATION_METHOD',
        AS_CODE_WORKSPACE = 'AS_CODE_WORKSPACE',
        CUSTOM_METADATA = 'CUSTOM_METADATA',
        INCIDENT_STATUS = 'INCIDENT_STATUS',
        TEAM = 'TEAM',
        DATA_PRODUCT = 'DATA_PRODUCT',
        INCIDENT_MUTING_STATUS = 'INCIDENT_MUTING_STATUS',
        MONITOR_MUTING_STATUS = 'MONITOR_MUTING_STATUS',
        MONITOR_HAS_PENDING_ANOMALIES = 'MONITOR_HAS_PENDING_ANOMALIES',
        DBT_RUN_STATUS = 'DBT_RUN_STATUS',
    }


}
